export default "__VITE_ASSET__190372db__"